export default __webpack_public_path__ + "assets/icons/time-left.0834fe4a.svg";